import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';

import { FranchiseDashboardComponent } from './franchise-dashboard/franchise-dashboard.component';
import { FranchiseUserComponent } from './franchise-user/franchise-user.component';
import { CallAlertComponent } from './call-alert/call-alert.component';
import { FranchiseRoutingModule } from './franchise-routing.module';
import { DataTablesModule } from 'angular-datatables/src/angular-datatables.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SubscriptionPlanComponent } from '../user/subscription-plan/subscription-plan.component';
import { UpdateReceiptComponent } from '../user/update-receipt/update-receipt.component';
import { ViewReceiptsComponent } from '../user/view-receipts/view-receipts.component';
import { AddReceiptComponent } from '../user/add-receipt/add-receipt.component';
import { UIModule } from '../shared/ui/ui.module';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { FranchseUserDetailsComponent } from './franchse-user-details/franchse-user-details.component';
import { AddUserComponent } from './add-user/add-user.component';
import { AddCallAlertFormComponent } from './add-call-alert-form/add-call-alert-form.component';
import { CallAlertListComponent } from './call-alert-list/call-alert-list.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Daterangepicker } from 'ng2-daterangepicker';
import { AddPropertyComponent } from './add-property/add-property.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { SocietyComponent } from './society/society.component';
import { ViewPropertyComponent } from './view-property/view-property.component';
import { AreaAlertListComponent } from './area-alert-list/area-alert-list.component';
import { ViewTpListComponent } from './view-tp-list/view-tp-list.component';
import { AddTpServiceComponent } from './add-tp-service/add-tp-service.component';
import { AddEppServiceComponent } from './add-epp-service/add-epp-service.component';
import { ViewEppListComponent } from './view-epp-list/view-epp-list.component';
import { AddNewEppComponent } from './add-new-epp/add-new-epp.component';
import { EditEppComponent } from './edit-epp/edit-epp.component';
import { AddAreaAlertComponent } from './add-area-alert/add-area-alert.component';
import { ViewAreaSmsAlertComponent } from './view-area-sms-alert/view-area-sms-alert.component';
import { ViewImageComponent } from './view-image/view-image.component';
import { ViewPpSmsAlertComponent } from './view-pp-sms-alert/view-pp-sms-alert.component';
import { ViewEmailPpAlertComponent } from './view-email-pp-alert/view-email-pp-alert.component';
import { AuctionAlertComponent } from './auction-alert/auction-alert.component';
import { ViewEmailEppAlertComponent } from './view-email-epp-alert/view-email-epp-alert.component';
import { ViewEmailTpAlertComponent } from './view-email-tp-alert/view-email-tp-alert.component';
import { EditAuctionAlertComponent } from './edit-auction-alert/edit-auction-alert.component';
import { AddAuctionAlertComponent } from './add-auction-alert/add-auction-alert.component';
import { AuctionEmailLogComponent } from './auction-email-log/auction-email-log.component';
import { AreaEmailLogComponent } from './area-email-log/area-email-log.component';
import { ViewPlanComponent } from './view-plan/view-plan.component';
import { UserDistrictComponent } from './user-district/user-district.component';
import { AddUserDistrictComponent } from './add-user-district/add-user-district.component';
import { LrsRequestComponent } from './lrs-request/lrs-request.component';
import { LrsUploadDocumentComponent } from './lrs-upload-document/lrs-upload-document.component';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { ViewLrsDocumentComponent } from './view-lrs-document/view-lrs-document.component';
import { LoginReportComponent } from './login-report/login-report.component';
import { AddSocietyComponent } from './add-society/add-society.component';
import { DailyCallAlertReportComponent } from './daily-call-alert-report/daily-call-alert-report.component';
import { ViewLoginReportComponent } from './view-login-report/view-login-report.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AddAuctionComponent } from './add-auction/add-auction.component';
import { SharedModule } from '../shared/shared.module';
import { EditDistrictComponent } from './edit-district/edit-district.component';
import { AddUserDistrictPopupComponent } from './add-user-district-popup/add-user-district-popup.component';
import { WhatsappReportComponent } from './whatsapp-report/whatsapp-report.component';
import { LandRecordOrdersComponent } from '../user/land-record-orders/land-record-orders.component';
import { AddServicesComponent } from './add-services/add-services.component';
import { ViewServicesComponent } from './view-services/view-services.component';
// import { ViewPropertyServicesComponent } from './view-property-services/view-property-services.component';




@NgModule({
  declarations: [FranchiseDashboardComponent,FranchiseUserComponent, CallAlertComponent,SubscriptionPlanComponent,UpdateReceiptComponent,ViewReceiptsComponent,AddReceiptComponent, FranchseUserDetailsComponent, AddUserComponent, AddCallAlertFormComponent, CallAlertListComponent, AddPropertyComponent, SocietyComponent, ViewPropertyComponent, AreaAlertListComponent, ViewTpListComponent, AddTpServiceComponent, AddEppServiceComponent, ViewEppListComponent, AddNewEppComponent, EditEppComponent,AddAreaAlertComponent, ViewAreaSmsAlertComponent, ViewImageComponent, ViewPpSmsAlertComponent, ViewEmailPpAlertComponent, AuctionAlertComponent, ViewEmailEppAlertComponent, ViewEmailTpAlertComponent, EditAuctionAlertComponent, AddAuctionAlertComponent, AuctionEmailLogComponent, AreaEmailLogComponent, ViewPlanComponent, UserDistrictComponent, AddUserDistrictComponent, LrsRequestComponent, LrsUploadDocumentComponent, ViewLrsDocumentComponent, LoginReportComponent, AddSocietyComponent, DailyCallAlertReportComponent, ViewLoginReportComponent, AddAuctionComponent, EditDistrictComponent, AddUserDistrictPopupComponent, WhatsappReportComponent, ViewServicesComponent, AddServicesComponent, LandRecordOrdersComponent],
  imports: [
    CommonModule,
    DataTablesModule,
    FranchiseRoutingModule,
    FileUploadModule,
    ReactiveFormsModule,
    FormsModule,
    UIModule,
    NgbModule,
    NgApexchartsModule,
    AutocompleteLibModule,
    AngularMaterialModule,
    NgSelectModule,
    Daterangepicker,
    SharedModule,
    MatCheckboxModule,
    MatIconModule
  ],
  entryComponents: [ViewLoginReportComponent,LrsUploadDocumentComponent,SubscriptionPlanComponent,SocietyComponent, UpdateReceiptComponent,AddUserComponent,AddCallAlertFormComponent,AddPropertyComponent,AddEppServiceComponent,ViewImageComponent,AddSocietyComponent, EditDistrictComponent, AddUserDistrictPopupComponent, AddServicesComponent],
})
export class FranchiseModule { }
